import { getCategoryHomeData } from '@/common/requests/data-fetch/get-category-home-data'

export const getLiveData = async () => {
  return getCategoryHomeData({ category: 'GN54' })
}
